import { UsersList } from 'widgets/users/ui/UsersList';
import { useAppDispatch } from 'app/store';
import { useEffect } from 'react';
import { setActionBtnTitle, setHeaderAction } from 'features/ui/model/uiSlice';

export const UsersMPPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderAction('create'));
    dispatch(setActionBtnTitle('Создать'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return <UsersList />;
};
